import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MyButton from '../../../utils/MyButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

import { FaTrashAlt, FaArrowLeft } from "react-icons/fa";

//import {eliminarCliente} from '../../../redux/actions/dataactions';

import { deleteCliente } from '../../../redux/actions/dataactions';


import './EliminarCliente.css';

export class EliminarCliente extends Component {

    state = {
        open: false
    };
    handleOpen = () => {
        this.setState({ open: true });
    }
    handleClose = () => {
        this.setState({ open: false });
    }
    delete = () => {
        //this.props.deleteScream(this.props.screamId);
        this.props.deleteCliente(this.props.clienteId);
        this.setState({ open: false });
    }

    render() {

        return (
            <div>
                <Fragment>
                    <div className="div-botoneliminarcliente">
                        <MyButton tip="Eliminar Cliente" onClick={this.handleOpen} >
                            <FaTrashAlt color="#03178C" className="icon-eliminarcliente"></FaTrashAlt>
                        </MyButton>
                    </div>

                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle sx={{ color: '#03178C', fontWeight: 'bold' }}>
                            <Typography variant="h6" component="span">¿Estás seguro de borrar este cliente?</Typography>
                        </DialogTitle>

                        <DialogActions>
                            <MyButton tip="Cerrar" onClick={this.handleClose}>
                                <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
                            </MyButton>
                            <MyButton tip="Borrar Cliente" onClick={this.delete}>
                                <FaTrashAlt color="#03178C" className="icon-formulario" />
                            </MyButton>
                        </DialogActions>

                    </Dialog>




                </Fragment>
            </div>
        )
    }
}

EliminarCliente.propTypes = {
    deleteCliente: PropTypes.func.isRequired,
    clienteId: PropTypes.string.isRequired
};

const mapActionsToProps = { deleteCliente };

const mapStateToProps = (state) => ({
    user: state.user
})



export default connect(mapStateToProps, mapActionsToProps)(EliminarCliente);